import styled from '@emotion/styled'
import { Button, theme } from '@hhgtech/hhg-components'

import { Calendar } from 'components/molecules/calendar'
import { Z_INDEX } from 'interfaces/constants'

export const StyledCalendarModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  align-items: flex-start;
  overflow: auto;

  width: 100vw;
  height: 100vh;
  z-index: ${Z_INDEX.headerContainerPopupSUbLevel};
  background-color: ${theme.colors.white};
  padding-top: 72px;
`

export const StyledCalendarModalCalendar = styled(Calendar)`
  width: 100%;

  > div:first-of-type {
    box-shadow: rgb(0 0 0 / 4%) 0px 10px 16px, rgb(0 0 0 / 4%) 0px 2px 8px,
      rgb(0 0 0 / 4%) 0px 0px 1px;
  }
`

export const StyledCalendarModalTodayButton = styled(Button)`
  font-size: 14px;
  font-weight: 700;
  color: ${theme.colors.primaryBase};
  margin-left: auto;
`

export const StyledCalendarModalCloseIcon = styled.img`
  width: 24px;
  height: 24px;
  cursor: pointer;
`

export const StyledCalendarModalTitleBar = styled.div`
  display: flex;
  align-items: center;
  padding: 16px;
  gap: 16px;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;

  z-index: ${Z_INDEX.adBlock};

  background-color: ${theme.colors.white};
`

export const StyledCalendarModalContent = styled.div``
